module.exports = __webpack_public_path__ + "img/diagrama-dentara.28f09edb.svg";